"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = require("app");
var React = __importStar(require("react"));
var Link_1 = __importDefault(require("../Link"));
var SidebarPages_1 = __importDefault(require("../SidebarPages"));
var AppSwitcher_1 = require("./AppSwitcher");
var HamburgerButton_1 = __importDefault(require("./HamburgerButton"));
var DOMPurify = __importStar(require("dompurify"));
var SidebarMenuComponent = /** @class */ (function (_super) {
    __extends(SidebarMenuComponent, _super);
    function SidebarMenuComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.pages = [
            _this.renderGroupList.bind(_this),
            _this.renderGroup.bind(_this),
            _this.renderAppSwitcher.bind(_this),
            _this.renderRegistrationModal.bind(_this)
        ];
        _this.handleGroupListItemClick = function (groupOpenIndex) {
            _this.setState({ groupOpenIndex: groupOpenIndex });
        };
        _this.handleBackToGroupListClick = function () {
            _this.setState({ groupOpenIndex: -1 });
        };
        _this.handleShowRegistrationModalClick = function () {
            _this.setState({ showModal: true });
        };
        _this.handleHideRegistrationModalClick = function () {
            _this.setState({ showModal: false });
        };
        _this.renderLogo = function () {
            var logoLink = _this.props.headerControls.logoTurbocorLink;
            var logoImageUrl = _this.props.headerControls.siteLogoItem.LogoImageUrl;
            var logoLinkUrl = _this.props.headerControls.siteLogoItem.LogoLinkUrl;
            var logoLinkName = _this.props.headerControls.siteLogoItem.LogoLinkName;
            var logoLinkTarget = _this.props.headerControls.siteLogoItem.LogoLinkTarget;
            if (logoImageUrl && logoImageUrl.length > 0) {
                return (React.createElement("div", { className: "header__menu__logo-wrapper" },
                    React.createElement("a", { className: "header__menu__logo", href: !!logoLinkUrl ? logoLinkUrl : "##", target: logoLinkTarget ? logoLinkTarget : "_self" },
                        React.createElement("img", { className: "logo", src: logoImageUrl, alt: "Turbocor" }))));
            }
            return (React.createElement("div", { className: "flaot-left" }, "\u00A0"));
        };
        _this.renderLoginMenu = function () {
            var _a = _this.props.loginMenu, isUserLoggedIn = _a.isUserLoggedIn, login = _a.login, logout = _a.logout, profile = _a.profile, welcomeMessage = _a.welcomeMessage, username = _a.username;
            if (!isUserLoggedIn) {
                if (!login.caption || !login.url) {
                    return null;
                }
                return (React.createElement("div", { className: "mobile-menu__login-wrapper" },
                    React.createElement("span", { className: "mobile-menu__login-item" },
                        React.createElement("a", { className: "paragraph-link", href: login.url }, login.caption)),
                    React.createElement("span", { className: "mobile-menu__login-item" },
                        React.createElement("label", { className: "paragraph-link", onClick: _this.handleShowRegistrationModalClick }, "Register"))));
            }
            return (React.createElement("div", { className: "mobile-menu__login-wrapper" },
                (!welcomeMessage || !username) ? null :
                    React.createElement("span", { className: "mobile-menu__login-name" },
                        welcomeMessage,
                        "\u00A0",
                        React.createElement("b", null, username)),
                (!profile.caption || !profile.url || !logout.caption || !logout.url) ? null :
                    React.createElement("div", { className: "mobile-menu__login-item-wrapper" },
                        React.createElement("span", { className: "mobile-menu__login-item" },
                            React.createElement("a", { className: "paragraph-link", href: profile.url }, profile.caption)),
                        React.createElement("span", { className: "mobile-menu__login-item" },
                            React.createElement("a", { className: "paragraph-link", href: logout.url }, logout.caption)))));
        };
        _this.state = {
            groupOpenIndex: -1,
            showAppSwitcher: _this.props.visibleAppSwitcher || false,
            showModal: false
        };
        return _this;
    }
    SidebarMenuComponent.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.visibleAppSwitcher !== prevState.showAppSwitcher) {
            return {
                groupOpenIndex: -1,
                showAppSwitcher: nextProps.visibleAppSwitcher,
                showModal: false
            };
        }
        return null;
    };
    SidebarMenuComponent.prototype.render = function () {
        return (React.createElement("div", { className: "mobile-menu__items-wrapper" },
            this.renderHeader(),
            this.renderLoginMenu(),
            this.renderBody(),
            this.renderRegistrationModal()));
    };
    SidebarMenuComponent.prototype.renderHeader = function () {
        var _a = this.props, close = _a.close, headerControls = _a.headerControls, toggleAppSwitcher = _a.toggleAppSwitcher;
        return (React.createElement("div", { className: "mobile-menu__header" },
            React.createElement("div", { className: "mobile-menu-wrapper" },
                this.renderLogo(),
                React.createElement("div", { className: "mobile-menu__item" }, !!headerControls.siteLanguageLabel && (0, AppSwitcher_1.AppSwitcherButton)({
                    onClick: AppSwitcher_1.AppSwitcherService.HasItems() ? toggleAppSwitcher : null,
                    language: headerControls.siteLanguageLabel
                }))),
            React.createElement(HamburgerButton_1.default, { onClick: close, extraClass: "header__menu-btn--close" })));
    };
    SidebarMenuComponent.prototype.renderGroupList = function () {
        var _this = this;
        var menuItems = this.props.menuItems;
        var onClick = function (field, i) {
            if (!field.isClickable) {
                _this.handleGroupListItemClick(i);
            }
            else {
                window.location.href = field.clickableLink.url;
            }
        };
        return (React.createElement("div", { key: "group-list", className: "sidebar-page-wrapper" },
            React.createElement("ul", { className: "group-list-items" }, menuItems.map(function (field, i) {
                return (React.createElement("li", { key: i, onClick: onClick.bind(_this, field, i), className: "group-list-item" },
                    React.createElement("div", { className: "group" },
                        React.createElement("div", { className: "group-wrapper" },
                            React.createElement("div", { className: "group__heading" },
                                React.createElement("i", { className: "icon-chevron-down-small" }),
                                !field.isClickable ? field.title : field.clickableLink.caption)))));
            }))));
    };
    SidebarMenuComponent.prototype.renderRegistrationModal = function () {
        var _a = this.props.headerControls.login, RegistrationDescription = _a.RegistrationDescription, RegistrationTitle = _a.RegistrationTitle;
        var mySafeHTML = DOMPurify.sanitize(RegistrationDescription);
        if (this.state.showModal) {
            return (React.createElement("div", { className: "login-popup-sidebar" },
                React.createElement("div", { className: "login-popup-body" },
                    React.createElement("div", { className: "login-popup-header" },
                        React.createElement("h2", { className: "message-form-title mb-12" },
                            " ",
                            RegistrationTitle),
                        React.createElement("a", { onClick: this.handleHideRegistrationModalClick, className: "close-login-popup" }, " ")),
                    React.createElement("div", { className: "popup-link" },
                        React.createElement("div", { dangerouslySetInnerHTML: { __html: mySafeHTML } })))));
        }
        return React.createElement("div", null, "\u00A0");
    };
    SidebarMenuComponent.prototype.renderGroup = function () {
        var menuItems = this.props.menuItems;
        var _a = this.state, groupOpenIndex = _a.groupOpenIndex, showAppSwitcher = _a.showAppSwitcher;
        return (React.createElement("div", { key: "group", className: "sidebar-page-wrapper" },
            React.createElement("div", { className: "menu-group" },
                React.createElement("div", { className: "menu-back" },
                    React.createElement("i", { className: "icon-chevron-down-small", onClick: this.handleBackToGroupListClick }),
                    React.createElement("div", { className: "menu__header-label", onClick: this.handleBackToGroupListClick }, menuItems[groupOpenIndex].title)),
                React.createElement("ul", { className: "menu-items" }, (0, app_1.safe)(menuItems[groupOpenIndex].links).map(function (item, i) {
                    return (React.createElement("li", { key: i, className: "menu-group__item" },
                        React.createElement(Link_1.default, { className: "menu-group__item__title", url: item.url, newWindow: item.newWindow }, item.caption)));
                })))));
    };
    SidebarMenuComponent.prototype.renderAppSwitcher = function () {
        var appData = AppSwitcher_1.AppSwitcherService.GetData();
        return (React.createElement("div", { className: "sidebar-page-wrapper" },
            React.createElement("div", { className: "menu-group" }, (0, AppSwitcher_1.AppSwitcherItemsList)({
                itemClass: "menu-group__item switcher-item",
                items: appData,
                listClass: "menu-items switcher-items",
            }))));
    };
    SidebarMenuComponent.prototype.renderBody = function () {
        var _a = this.state, groupOpenIndex = _a.groupOpenIndex, showAppSwitcher = _a.showAppSwitcher;
        return (React.createElement("div", { className: "mobile-menu__body" },
            React.createElement(SidebarPages_1.default, { currentPageIndex: showAppSwitcher ? 2 : groupOpenIndex >= 0 ? 1 : 0, pages: this.pages })));
    };
    return SidebarMenuComponent;
}(React.Component));
exports.default = SidebarMenuComponent;
